/**
 * The giver's "Waiting m:ss" stamp (A4): when THIS TAB saw the wait begin,
 * kept in sessionStorage so a reload resumes it. The server sends no join
 * time, so this is the honest clock the page can keep.
 *
 * The queue store owns its lifecycle (#992 F4): a successful join starts a
 * fresh one and EVERY exit from WAITING/PINGED forgets it, whichever path
 * ended the wait and whether or not the waiting screen was mounted.
 */
export const GIVER_WAIT_KEY = 'empathyQueueJoinedAt:giver';

/** Forget a finished wait, so the next one starts at 0:00. */
export function clearElapsed(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // Storage unavailable: nothing was kept.
  }
}
